import { put } from 'redux-saga/effects'
import importer from 'common/importer'
/* ACTIONS */
const AuthCustomActions = importer('Stores/AuthCustom/Actions')

/* ENDPOINT */
const { mulesoft } = importer('APIs/auth', null)
const { register } = mulesoft

export default function * main ({ donor }) {
  try {
    yield put(AuthCustomActions.registerLoading())
    const res = yield register(donor)

    if (res.status === 200 || res.status === 304 || res.status === 201) {
      yield put(AuthCustomActions.registerSuccess(res))
    } else {
      throw Error(res)
    }
  } catch (error) {
    yield put(AuthCustomActions.registerFailure(error.response.data))
  }
}
